module.exports = __webpack_public_path__ + "static/vibe-icon-79cfb7a10489b6599d3c4f8e65b51f08.svg";